import React, { useContext } from 'react';
import { DeleteOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Input, Segmented, Space, Tooltip } from 'antd';

import RemoteAccessBuildingAuditContext from '@totem/components/services/remoteAccess/v2/buildingAudit/RemoteAccessBuildingAuditContext';
import { StatusFilter } from '@totem/components/services/remoteAccess/v2/users/types';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

type Props = {
  onRemoveSelected: () => void;
};

const RemoteAccessBuildingAuditSearchBar = ({ onRemoveSelected }: Props) => {
  const {
    rows,
    emailSearch,
    setEmailSearch,
    nameSearch,
    setNameSearch,
    statusFilter,
    setStatusFilter,
    selectedUserIds,
    canEdit,
    onRefresh,
  } = useContext(RemoteAccessBuildingAuditContext);

  return (
    <Space wrap size="middle" style={{ marginBottom: 16 }}>
      <RecordCountBadge count={rows.length} />
      <Input
        placeholder="Email Search"
        value={emailSearch}
        allowClear
        onChange={(evt) => setEmailSearch(evt.target.value)}
        style={{ width: 220 }}
      />
      <Input
        placeholder="Name Search"
        value={nameSearch}
        allowClear
        onChange={(evt) => setNameSearch(evt.target.value)}
        style={{ width: 220 }}
      />
      <Segmented<StatusFilter>
        value={statusFilter}
        onChange={setStatusFilter}
        options={[
          { label: 'All', value: 'all' },
          { label: 'Active', value: 'ACTIVE' },
          { label: 'Stale', value: 'STALE' },
          { label: 'Never Logged In', value: 'NEVER LOGGED IN' },
        ]}
      />
      {canEdit && (
        <Button
          danger
          icon={<DeleteOutlined />}
          disabled={selectedUserIds.length === 0}
          onClick={onRemoveSelected}
        >
          Remove Selected ({selectedUserIds.length})
        </Button>
      )}
      <Tooltip title="Refresh">
        <Button icon={<ReloadOutlined />} onClick={onRefresh} />
      </Tooltip>
    </Space>
  );
};

export default RemoteAccessBuildingAuditSearchBar;
